import Vue from 'vue'
import { foldazApi } from 'api'
import {
  SET_ATTACHMENTS,
  SET_ATTACHMENT,
  MARK_ATTACHMENT_FOR_DELETION,
  REMOVE_ATTACHMENT
} from './types'

export const state = {
  form: {
    attachments: []
  }
}

export const mutations = {
  [SET_ATTACHMENTS] (state, value) {
    state.form.attachments = value
  },
  [SET_ATTACHMENT] (_, { attachment, value }) {
    Object.keys(attachment).forEach(k => { delete attachment[k] })
    Object.keys(value).forEach(k => { attachment[k] = value[k] })
  },
  [MARK_ATTACHMENT_FOR_DELETION] (_, attachment) {
    Vue.set(attachment, 'markedForDeletion', true)
  },
  [REMOVE_ATTACHMENT] (state, attachment) {
    state.form.attachments = state.form.attachments.filter(a => a !== attachment)
  }
}

export const actions = {
  set ({ commit }, value) {
    commit(SET_ATTACHMENTS, value)
  },
  remove ({ commit }, attachment) {
    if (attachment.id) {
      commit(MARK_ATTACHMENT_FOR_DELETION, attachment)
    } else {
      commit(REMOVE_ATTACHMENT, attachment)
    }
  },
  postRemote ({ commit }, { attachment, contentId }) {
    return foldazApi.post('/attachments', {
      attachment: {
        content_id: contentId,
        remote_file_url: attachment.src
      }
    })
      .then(({ data }) => commit(SET_ATTACHMENT, { attachment, value: data.attachment }))
  },
  postLocal ({ commit }, { attachment, contentId }) {
    const formData = new FormData()
    formData.append('attachment[file]', attachment.file)
    formData.append('attachment[content_id]', contentId)
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return foldazApi.post('/attachments', formData, config)
      .then(({ data }) => commit(SET_ATTACHMENT, { attachment, value: data.attachment }))
  },
  destroy ({ commit }, attachment) {
    return foldazApi.delete(`/attachments/${attachment.id}`)
      .then(({ data }) => commit(REMOVE_ATTACHMENT, attachment))
  },
  submit ({ dispatch, state, rootState }) {
    const contentId = rootState.contentForm.form.id
    return Promise.all(
      state.form.attachments.map(a => {
        if (a.isRemote) {
          return dispatch('postRemote', { attachment: a, contentId })
        } else if (a.file) {
          return dispatch('postLocal', { attachment: a, contentId })
        } else if (a.markedForDeletion) {
          return dispatch('destroy', a)
        } else {
          return Promise.resolve()
        }
      })
    )
  }
}

export const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentAttachments.js